import { render, staticRenderFns } from "./drawer.component.vue?vue&type=template&id=0074717f&scoped=true&"
import script from "./drawer.component.vue?vue&type=script&lang=ts&"
export * from "./drawer.component.vue?vue&type=script&lang=ts&"
import style0 from "./drawer.component.vue?vue&type=style&index=0&id=0074717f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074717f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VNavigationDrawer,VSpacer})
